import {
  Box,
  Button,
  ButtonGroup, ListItemIcon, ListItemText, MenuItem,
} from '@mui/material';
import { tableHeaderStyle } from './tableHeaderAndBodyStyle';
import { fontAwesomeIcons } from '../User/Component/OrderManagement/TableCustomeIcon';
import { deleteCommonFunction } from '../Comman/DeleteCommonFun/DeleteCommonFunction';
import { CheckmarkCircle20Regular, DismissCircle20Regular, PresenceAway16Regular, MailDismiss20Regular, ThumbLikeRegular, DocumentArrowDown20Regular, Eye20Filled, PersonEdit20Regular, Mail20Regular, ArrowDownload20Filled, ThumbDislikeRegular, CalendarAdd20Regular, Delete20Regular, Edit20Regular, Send20Regular, DrawerArrowDownload20Filled } from '@fluentui/react-icons';
import { EmailMarketingPermissions, MenuPermissions, StockPermissions, TableReservation, UserPermissionAllData, userPermissionType } from '../Comman/UserPermission';
import Loader from '../Comman/Loader/Loader';
import { TbFileDownload } from "react-icons/tb";
import moment from 'moment';
import { Download } from '@mui/icons-material';


const userPermissionType_ = userPermissionType === "groupadmin"


export const tableOption = ({ getMenuList, url23,
  handleClickColum_, handleSubmitActive, windowHeight,
  filterData,
  DisplayCol,
  handleFilterClick }) => ({
    icons: fontAwesomeIcons,
    positionGlobalFilter: "left",
    muiTableHeadCellProps: {
      sx: tableHeaderStyle?.headerTitle
    },
    muiTableBodyCellProps: {
      sx: tableHeaderStyle?.headerCell
    },
    muiTableBodyRowProps: { hover: false },
    enableRowSelection: true,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: false,
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
      sx: { marginLeft: "auto" },
    },
    // autoResetPageIndex: false,
    state: { getMenuList },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
      shape: 'rounded',
      variant: 'outlined',
    },
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
          <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
              fill="#344054"
            />
          </svg>
          } > Display</Button>
          <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
            startIcon={<svg
              width={19}
              height={18}
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
                fill="#344054"
              />
            </svg>
            }>Filter</Button>
        </ButtonGroup>
      </Box>
    ),

    renderRowActionMenuItems: ({ closeMenu, row }) => [

      (userPermissionType_ || MenuPermissions?.access?.includes("edit")) && (
        <MenuItem
          className='email_'
          onClick={() => {
            handleSubmitActive(row?.original?._id, !row?.original?.is_active)
            closeMenu()
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Send20Regular />
          </ListItemIcon>
          {row?.original?.is_active === true ? "Inactive" : "Active"}
        </MenuItem>),
      (userPermissionType_ || MenuPermissions?.access?.includes("delete")) && (
        <MenuItem
          className='delete_'
          onClick={() => {
            closeMenu();
            if (url23 === "menu_management") {
              // const endpoint = '/groupadmin/menu';
              // deleteData(endpoint, row?.original?._id, getMenuList, "Menu has been deleted successfully.");
              deleteCommonFunction(`/groupadmin/menu/${row?.original?._id}`, "Menu has been deleted successfully.", () => getMenuList());
            }
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
          </ListItemIcon>
          Delete
        </MenuItem>)
    ],

    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 40, //set custom width
        muiTableHeadCellProps: {
          align: 'start', //change head cell props
        },
        muiTableRowCellProps: {
          align: 'center',
        },
      },
      'mrt-row-numbers': {
        muiTableHeadCellProps: {
          sx: {
            fontSize: '1.2rem',
          },
        },
      },
      'mrt-row-select': {
        enableColumnActions: true,
        enableHiding: true,
        size: 30,
      },
    },
    enableSortingRemoval: false,
    // renderRowActions:({
    //   row
    // }) => 
    // <div style={{
    //   display: 'flex',
    //   flexWrap: 'nowrap',
    //   justifyContent : "center",
    //   alignItems : "center"
    // }}>
    //         <button style={{ border : "1px solid #D0D5DD"}} 
    //     className="btn btn-outline btn-outline-secondary px-2 py-1">
    //     <svg style={{color :"#344054"}} width="16" height="16" viewBox="0 0 16 16" fill="#344054" xmlns="http://www.w3.org/2000/svg">
    //         <path d="M3.28149 4.7998C2.42233 4.7998 1.96315 5.81172 2.52891 
    //         6.45831L6.94637 11.5068C7.50415 12.1443 8.49581 12.1443 9.05359 11.5068L13.4711 
    //         6.45831C14.0368 5.81173 13.5776 4.7998 12.7185 4.7998H3.28149Z" fill="#344054" />
    //     </svg>
    //   </button>
    //     </div> 
    // enableRowNumbers: true,
  });

export const tableOptionSubcription = ({ getMenuList, url23,
  handleClickColum_, handleSubmitActive, windowHeight, handleShow,
  filterData,
  DisplayCol,
  handleFilterClick }) => ({
    icons: fontAwesomeIcons,
    positionGlobalFilter: "left",
    muiTableHeadCellProps: {
      sx: tableHeaderStyle?.headerTitle
    },
    muiTableBodyCellProps: {
      sx: tableHeaderStyle?.headerCell
    },
    muiTableBodyRowProps: { hover: false },
    enableRowSelection: true,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: false,
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
      sx: { marginLeft: "auto" },
    },
    // autoResetPageIndex: false,
    state: { getMenuList },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
      shape: 'rounded',
      variant: 'outlined',
    },
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        {/* <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
            <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
              width={16}
              height={16}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
                fill="#344054"
              />
            </svg>
            } > Display</Button>
            <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
              startIcon={<svg
                width={19}
                height={18}
                viewBox="0 0 19 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
                  fill="#344054"
                />
              </svg>
              }>Filter</Button>
          </ButtonGroup> */}
      </Box>
    ),

    renderRowActionMenuItems: ({ closeMenu, row }) => [

      (userPermissionType_ || MenuPermissions?.access?.includes("edit")) && (
        <MenuItem
          className='email_'
          disabled={!row?.original?.invoice_link}
          onClick={() => {
            window.open(`${row?.original?.invoice_link}`)
            closeMenu();
          }}
          // onClick={() => {
          //   handleSubmitActive(row?.original?._id, !row?.original?.is_active)
          //   closeMenu()
          // }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <DocumentArrowDown20Regular />
          </ListItemIcon>
          Download Invoice
        </MenuItem>),
      // (userPermissionType_ || MenuPermissions?.access?.includes("delete")) && (
      //   <MenuItem
      //     className='delete_'
      //     onClick={() => {
      //       closeMenu();
      //       handleShow()
      //         // deleteCommonFunction(`/groupadmin/menu/${row?.original?._id}`, "Menu has been deleted successfully.", () => getMenuList());
      //     }}
      //     sx={{ m: 0 }}
      //   >
      //     <ListItemIcon>
      //       <CalendarAdd20Regular style={{ color: "rgb(242, 80, 66)" }} />
      //     </ListItemIcon>
      //     Cancel Subscription
      //   </MenuItem>
      //   )
    ],

    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 40, //set custom width
        muiTableHeadCellProps: {
          align: 'start', //change head cell props
        },
        muiTableRowCellProps: {
          align: 'center',
        },
      },
      'mrt-row-numbers': {
        muiTableHeadCellProps: {
          sx: {
            fontSize: '1.2rem',
          },
        },
      },
      'mrt-row-select': {
        enableColumnActions: true,
        enableHiding: true,
        size: 30,
      },
    },
    enableSortingRemoval: false,
  });

export const tableOptionStockManagment = ({ getStockList, url23,
  handleClickColum_, windowHeight, handleSubmitEdit,
  filterData,
  DisplayCol,
  handleFilterClick,
  filterButtonColor,
  showMenu,
  handleShow,
  handleFilterColor, Type,
  isRefetching,
  handleShowMenu,
  globalFilter,
  sorting,
  setGlobalFilter,
  setPagination,
  setSorting,
  rowCount,
  isLoading,
  pagination,


}) => ({
  icons: fontAwesomeIcons,
  positionGlobalFilter: "left",
  muiTableHeadCellProps: {
    sx: tableHeaderStyle?.headerTitle
  },
  muiTableBodyCellProps: {
    sx: tableHeaderStyle?.headerCell
  },
  muiTableBodyRowProps: { hover: false },
  enableColumnFilters: false,
  onGlobalFilterChange: setGlobalFilter,
  onPaginationChange: setPagination,
  onSortingChange: setSorting,
  enableFilterMatchHighlighting: true,
  rowCount,
  state: {
    // columnFilters,
    globalFilter,
    isLoading,
    pagination,
    // showAlertBanner: isError,
    showProgressBars: isRefetching,
    sorting,
  },
  enableFacetedValues: true,
  enableRowActions: true,
  enableRowSelection: false,
  enableColumnFilters: false,
  positionToolbarAlertBanner: 'bottom',
  muiSearchTextFieldProps: {
    size: 'small',
    variant: 'outlined',
    sx: { marginLeft: "auto" },
  },
  enableSortingRemoval: false,
  enableColumnActions: false,

  initialState: {
    showColumnFilters: false,
    showGlobalFilter: true,
    columnPinning: {
      left: ['mrt-row-expand', 'mrt-row-select'],
      right: ['mrt-row-actions'],
    },
  },
  muiPaginationProps: {
    color: 'secondary',
    rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
    shape: 'rounded',
    variant: 'outlined',
  },
  paginationDisplayMode: 'pages',
  renderToolbarInternalActions: ({ table }) => (
    <Box>
      <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
        <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
          width={16}
          height={16}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
            fill="#344054"
          />
        </svg>
        } > Display</Button>
        {/* <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
          startIcon={<svg
            width={19}
            height={18}
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
              fill="#344054"
            />
          </svg>
          }>Filter</Button> */}
      </ButtonGroup>
    </Box>
  ),

  renderRowActionMenuItems: ({ closeMenu, row }) => [


    (userPermissionType === "groupadmin" || StockPermissions?.access?.includes("edit")) && (
      <MenuItem
        className='email_'
        onClick={() => {
          handleSubmitEdit(row?.original)
          closeMenu()
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <Edit20Regular />
        </ListItemIcon>
        Edit
      </MenuItem>),

    (userPermissionType === "groupadmin" || StockPermissions?.access?.includes("delete")) && (
      <MenuItem
        className='delete_'
        onClick={() => {
          closeMenu();
          if (url23 === "stock_management") {
            deleteCommonFunction(`/groupadmin/branch_stock/${row?.original?._id}`, "Stock has been deleted successfully.", () => getStockList());
          }
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
        </ListItemIcon>
        Delete
      </MenuItem>
    )
  ],
  manualSorting: true,
  manualFiltering: true,
  manualPagination: true,
  enableStickyHeader: true,
  enableStickyFooter: true,
  muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
  displayColumnDefOptions: {
    'mrt-row-actions': {
      size: 40, //set custom width
      muiTableHeadCellProps: {
        align: 'start', //change head cell props
      },
      muiTableRowCellProps: {
        align: 'center',
      },
    },
    'mrt-row-numbers': {
      muiTableHeadCellProps: {
        sx: {
          fontSize: '1.2rem',
        },
      },
    },
    'mrt-row-select': {
      enableColumnActions: true,
      enableHiding: true,
      size: 30,
    },
  },
  enableSortingRemoval: false,
});

export const tableOptionTableReservationList = ({ getStockList, url23,
  handleClickColum_, windowHeight, handleSubmitEdit, handleShowTableCancel,
  filterData, handleSubmitActive,
  DisplayCol,
  handleFilterClick,
  filterButtonColor,
  showMenu,
  handleShow,
  handleFilterColor, Type,
  isRefetching,
  handleShowMenu,
  globalFilter,
  sorting,
  setGlobalFilter,
  setPagination,
  setSorting,
  rowCount,
  isLoading,
  pagination,

  selected
}) => ({
  icons: fontAwesomeIcons,
  positionGlobalFilter: "left",
  muiTableHeadCellProps: {
    sx: tableHeaderStyle?.headerTitle
  },
  muiTableBodyCellProps: {
    sx: tableHeaderStyle?.headerCell
  },
  muiTableBodyRowProps: { hover: false },
  enableColumnFilters: false,
  onGlobalFilterChange: setGlobalFilter,
  onPaginationChange: setPagination,
  onSortingChange: setSorting,
  enableFilterMatchHighlighting: true,
  rowCount,
  state: {
    // columnFilters,
    globalFilter,
    isLoading,
    pagination,
    // showAlertBanner: isError,
    showProgressBars: isRefetching,
    sorting,
  },
  enableFacetedValues: true,
  enableRowActions: true,
  enableRowSelection: false,
  enableColumnFilters: false,
  positionToolbarAlertBanner: 'bottom',
  muiSearchTextFieldProps: {
    size: 'small',
    variant: 'outlined',
    sx: { marginLeft: "auto" },
  },
  enableSortingRemoval: false,
  enableColumnActions: false,

  initialState: {
    showColumnFilters: false,
    showGlobalFilter: true,
    columnPinning: {
      left: ['mrt-row-expand', 'mrt-row-select'],
      right: ['mrt-row-actions'],
    },
  },
  muiPaginationProps: {
    color: 'secondary',
    rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
    shape: 'rounded',
    variant: 'outlined',
  },
  paginationDisplayMode: 'pages',
  renderToolbarInternalActions: ({ table }) => (
    <Box>
      <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
        <Button onClick={handleClickColum_} style={{ background: handleFilterColor() }} className='button_group buttonDisplay' table={table} startIcon={<svg
          width={16}
          height={16}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
            fill="#344054"
          />
        </svg>
        } > Display</Button>
        <Button onClick={handleFilterClick}
          // disabled={selected === "allData"}
          style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
          startIcon={<svg
            width={19}
            height={18}
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
              fill="#344054"
            />
          </svg>
          }>Filter</Button>
      </ButtonGroup>
    </Box>
  ),

  renderRowActionMenuItems: ({ closeMenu, row }) => [


    (userPermissionType === "groupadmin" || TableReservation?.access?.includes("edit")) && (
      <MenuItem
        className='email_'
        disabled={row?.original?.status !== "pending"} // Disable when status is not "pending"
        style={{
          cursor: row?.original?.status !== "pending" ? "not-allowed" : "pointer",
          // opacity: rowData?.status !== "pending" ? 0.5 : 1, // Dim the button when disabled
        }}
        onClick={() => {
          // handleSubmitEdit(row?.original, "reserved");
          handleSubmitEdit(row?.original, "accepted");
          closeMenu()
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <CheckmarkCircle20Regular />
        </ListItemIcon>
        Accept Reservation
      </MenuItem>),

    (userPermissionType === "groupadmin" || TableReservation?.access?.includes("edit")) && (
      <MenuItem
        className='delete_'
        disabled={row?.original?.status === "cancelled"} // Disable when status is not "cancelled"
        style={{
          cursor: row?.original?.status === "cancelled" ? "not-allowed" : "pointer",
          // opacity: rowData?.status !== "cancelled" ? 0.5 : 1, // Dim the button when disabled
        }}
        onClick={() => {
          closeMenu();
          handleSubmitEdit(row?.original, "cancelled");
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <DismissCircle20Regular style={{ color: "rgb(242, 80, 66)" }} />
        </ListItemIcon>
        Cancel Reservation
      </MenuItem>
    ),
    (userPermissionType === "groupadmin" || TableReservation?.access?.includes("edit")) && (
      <MenuItem
        disabled={row?.original?.status === "pending" ? true : false} // Disable when status is not "pending"
        style={{
          cursor: row?.original?.status === "pending" ? "not-allowed" : "pointer",
          // opacity: rowData?.status !== "pending" ? 0.5 : 1, // Dim the button when disabled
        }}
        className='email_'
        onClick={() => {
          handleSubmitEdit(row?.original, "Send Email");
          closeMenu()
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <Mail20Regular />
        </ListItemIcon>
        Send Email
      </MenuItem>),

    (userPermissionType === "groupadmin" || TableReservation?.access?.includes("edit")) && (
        <MenuItem
          
          className='email_'
          onClick={() => {
            closeMenu();
            handleSubmitEdit(row?.original, "Edit Message");
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Edit20Regular />
          </ListItemIcon>
          Edit Message
        </MenuItem>
    ),

    <MenuItem
      className='email_'
      onClick={() => {
        handleSubmitEdit(row?.original, "Reschedule Reservation");
        closeMenu()
      }}
      sx={{ m: 0 }}
      style={{
        cursor: "pointer",
        // opacity: rowData?.status !== "pending" ? 0.5 : 1, // Dim the button when disabled
      }}
    >
      <ListItemIcon style={{ marginLeft: 4 }}>
        <PresenceAway16Regular />
      </ListItemIcon>
      Reschedule Reservation
    </MenuItem>,



  ],
  manualSorting: true,
  manualFiltering: true,
  manualPagination: true,
  enableStickyHeader: true,
  enableStickyFooter: true,
  muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
  displayColumnDefOptions: {
    'mrt-row-actions': {
      size: 40, //set custom width
      muiTableHeadCellProps: {
        align: 'start', //change head cell props
      },
      muiTableRowCellProps: {
        align: 'center',
      },
    },
    'mrt-row-numbers': {
      muiTableHeadCellProps: {
        sx: {
          fontSize: '1.2rem',
        },
      },
    },
    'mrt-row-select': {
      enableColumnActions: true,
      enableHiding: true,
      size: 30,
    },
  },
  enableSortingRemoval: false,
});

export const tableOptionTableReservationListAllData = ({ getStockList, url23,
  handleClickColum_, windowHeight, handleSubmitEdit, handleShowTableCancel,
  filterData, handleSubmitActive,
  DisplayCol,
  handleFilterClick,
  filterButtonColor,
  showMenu,
  handleShow,
  handleFilterColor, Type,
  isRefetching,
  handleShowMenu,
  globalFilterAllData,
  sortingAllData,
  setGlobalFilterAllData,
  setPaginationAllData,
  setSortingAllData,
  rowCount,
  isLoading,
  paginationAllData,


}) => ({
  icons: fontAwesomeIcons,
  positionGlobalFilter: "left",
  muiTableHeadCellProps: {
    sx: tableHeaderStyle?.headerTitle
  },
  muiTableBodyCellProps: {
    sx: tableHeaderStyle?.headerCell
  },
  muiTableBodyRowProps: { hover: false },
  enableColumnFilters: false,
  onGlobalFilterChange: setGlobalFilterAllData,
  onPaginationChange: setPaginationAllData,
  onSortingChange: setSortingAllData,
  enableFilterMatchHighlighting: true,
  rowCount,
  state: {
    // columnFilters,
    globalFilterAllData,
    isLoading,
    paginationAllData,
    // showAlertBanner: isError,
    showProgressBars: isRefetching,
    sortingAllData,
  },
  enableFacetedValues: true,
  enableRowActions: true,
  enableRowSelection: false,
  enableColumnFilters: false,
  positionToolbarAlertBanner: 'bottom',
  muiSearchTextFieldProps: {
    size: 'small',
    variant: 'outlined',
    sx: { marginLeft: "auto" },
  },
  enableSortingRemoval: false,
  enableColumnActions: false,

  initialState: {
    showColumnFilters: false,
    showGlobalFilter: true,
    columnPinning: {
      left: ['mrt-row-expand', 'mrt-row-select'],
      right: ['mrt-row-actions'],
    },
  },
  muiPaginationProps: {
    color: 'secondary',
    rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
    shape: 'rounded',
    variant: 'outlined',
  },
  paginationDisplayMode: 'pages',
  renderToolbarInternalActions: ({ table }) => (
    <Box>
      <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
        <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
          width={16}
          height={16}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
            fill="#344054"
          />
        </svg>
        } > Display</Button>
        <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
          startIcon={<svg
            width={19}
            height={18}
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
              fill="#344054"
            />
          </svg>
          }>Filter</Button>
      </ButtonGroup>
    </Box>
  ),

  renderRowActionMenuItems: ({ closeMenu, row }) => [


    (userPermissionType === "groupadmin" || TableReservation?.access?.includes("edit")) && (
      <MenuItem
        className='email_'
        disabled={row?.original?.status !== "pending"} // Disable when status is not "pending"
        style={{
          cursor: row?.original?.status !== "pending" ? "not-allowed" : "pointer",
          // opacity: rowData?.status !== "pending" ? 0.5 : 1, // Dim the button when disabled
        }}
        onClick={() => {
          // handleSubmitEdit(row?.original, "reserved");
          handleSubmitEdit(row?.original, "accepted");
          closeMenu()
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <CheckmarkCircle20Regular />
        </ListItemIcon>
        Accept Reservation
      </MenuItem>),

    (userPermissionType === "groupadmin" || TableReservation?.access?.includes("edit")) && (
      <MenuItem
        className='delete_'
        disabled={row?.original?.status === "cancelled"} // Disable when status is not "cancelled"
        style={{
          cursor: row?.original?.status === "cancelled" ? "not-allowed" : "pointer",
          // opacity: rowData?.status !== "cancelled" ? 0.5 : 1, // Dim the button when disabled
        }}
        onClick={() => {
          closeMenu();
          handleSubmitEdit(row?.original, "cancelled");
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <DismissCircle20Regular style={{ color: "rgb(242, 80, 66)" }} />
        </ListItemIcon>
        Cancel Reservation
      </MenuItem>
    ),
    (userPermissionType === "groupadmin" || TableReservation?.access?.includes("edit")) && (
      <MenuItem
        disabled={row?.original?.status === "pending" ? true : false} // Disable when status is not "pending"
        style={{
          cursor: row?.original?.status === "pending" ? "not-allowed" : "pointer",
          // opacity: rowData?.status !== "pending" ? 0.5 : 1, // Dim the button when disabled
        }}
        className='email_'
        onClick={() => {
          handleSubmitEdit(row?.original, "Send Email");
          closeMenu()
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <Mail20Regular />
        </ListItemIcon>
        Send Email
      </MenuItem>),

    <MenuItem
      className='email_'
      onClick={() => {
        handleSubmitEdit(row?.original, "Reschedule Reservation");
        closeMenu()
      }}
      sx={{ m: 0 }}
      style={{
        cursor: "pointer",
        // opacity: rowData?.status !== "pending" ? 0.5 : 1, // Dim the button when disabled
      }}
    >
      <ListItemIcon style={{ marginLeft: 4 }}>
        <PresenceAway16Regular />
      </ListItemIcon>
      Reschedule Reservation
    </MenuItem>,
    // (userPermissionType === "groupadmin" || TableReservation?.access?.includes("edit")) && (
    //   <MenuItem
    //     className='delete_'
    //     onClick={() => {
    //       closeMenu();
    //       handleSubmitEdit(row?.original, "Reject Email");
    //     }}
    //     sx={{ m: 0 }}
    //   >
    //     <ListItemIcon>
    //       <MailDismiss20Regular style={{ color: "rgb(242, 80, 66)" }} />
    //     </ListItemIcon>
    //     Reject Email
    //   </MenuItem>
    // ),
  ],
  manualSorting: true,
  manualFiltering: true,
  manualPagination: true,
  enableStickyHeader: true,
  enableStickyFooter: true,
  muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
  displayColumnDefOptions: {
    'mrt-row-actions': {
      size: 40, //set custom width
      muiTableHeadCellProps: {
        align: 'start', //change head cell props
      },
      muiTableRowCellProps: {
        align: 'center',
      },
    },
    'mrt-row-numbers': {
      muiTableHeadCellProps: {
        sx: {
          fontSize: '1.2rem',
        },
      },
    },
    'mrt-row-select': {
      enableColumnActions: true,
      enableHiding: true,
      size: 30,
    },
  },
  enableSortingRemoval: false,
});

export const tableOptionStockViewList = ({ getStockList, url23,
  handleClickColum_, windowHeight, handleSubmitEdit,
  filterData,
  DisplayCol,
  handleFilterClick,
  filterButtonColor,
  showMenu,
  handleShow,
  handleFilterColor, Type,
  isRefetching,
  handleShowMenu,
  globalFilter,
  sorting,
  setGlobalFilter,
  setPagination,
  setSorting,
  rowCount,
  isLoading,
  pagination,
}) => ({
  icons: fontAwesomeIcons,
  positionGlobalFilter: "left",
  muiTableHeadCellProps: {
    sx: tableHeaderStyle?.headerTitle
  },
  muiTableBodyCellProps: {
    sx: tableHeaderStyle?.headerCell
  },
  muiTableBodyRowProps: { hover: false },
  enableColumnFilters: false,
  onGlobalFilterChange: setGlobalFilter,
  onPaginationChange: setPagination,
  onSortingChange: setSorting,
  enableFilterMatchHighlighting: true,
  rowCount,
  state: {
    // columnFilters,
    globalFilter,
    isLoading,
    pagination,
    // showAlertBanner: isError,
    showProgressBars: isRefetching,
    sorting,
  },
  enableFacetedValues: true,
  enableRowActions: true,
  enableRowSelection: false,
  enableColumnFilters: false,
  positionToolbarAlertBanner: 'bottom',
  muiSearchTextFieldProps: {
    size: 'small',
    variant: 'outlined',
    sx: { marginLeft: "auto" },
  },
  enableSortingRemoval: false,
  enableColumnActions: false,

  initialState: {
    showColumnFilters: false,
    showGlobalFilter: true,
    columnPinning: {
      left: ['mrt-row-expand', 'mrt-row-select'],
      right: ['mrt-row-actions'],
    },
  },
  muiPaginationProps: {
    color: 'secondary',
    rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
    shape: 'rounded',
    variant: 'outlined',
  },
  paginationDisplayMode: 'pages',
  renderToolbarInternalActions: ({ table }) => (
    <Box>
      <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
        <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
          width={16}
          height={16}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
            fill="#344054"
          />
        </svg>
        } > Display</Button>
        <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
          startIcon={<svg
            width={19}
            height={18}
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
              fill="#344054"
            />
          </svg>
          }>Filter</Button>
      </ButtonGroup>
    </Box>
  ),

  renderRowActionMenuItems: ({ closeMenu, row }) => [

    (userPermissionType === "groupadmin" || StockPermissions?.access?.includes("edit")) && (
      <MenuItem
        className='email_'
        onClick={() => {
          handleSubmitEdit(row?.original)
          closeMenu()
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <Edit20Regular />
        </ListItemIcon>
        Edit
      </MenuItem>),
  ],

  manualSorting: true,
  manualFiltering: true,
  manualPagination: true,
  enableStickyHeader: true,
  enableStickyFooter: true,
  muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
  displayColumnDefOptions: {
    'mrt-row-actions': {
      size: 40, //set custom width
      muiTableHeadCellProps: {
        align: 'start', //change head cell props
      },
      muiTableRowCellProps: {
        align: 'center',
      },
    },
    'mrt-row-numbers': {
      muiTableHeadCellProps: {
        sx: {
          fontSize: '1.2rem',
        },
      },
    },
    'mrt-row-select': {
      enableColumnActions: true,
      enableHiding: true,
      size: 30,
    },
  },
  enableSortingRemoval: false,
});


export const tableOptionInventory = ({ url23,
  handleClickColum_, handleSubmitActive, windowHeight, handleSubmitEdit,
  filterData,
  DisplayCol,
  handleFilterClick }) => ({
    icons: fontAwesomeIcons,
    positionGlobalFilter: "left",
    muiTableHeadCellProps: {
      sx: tableHeaderStyle?.headerTitle
    },
    muiTableBodyCellProps: {
      sx: tableHeaderStyle?.headerCell
    },
    muiTableBodyRowProps: { hover: false },
    enableRowSelection: true,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: false,
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
      sx: { marginLeft: "auto" },
    },
    // autoResetPageIndex: false,
    // state: { getMenuList },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
      shape: 'rounded',
      variant: 'outlined',
    },
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
          <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
              fill="#344054"
            />
          </svg>
          } > Display</Button>
          <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
            startIcon={<svg
              width={19}
              height={18}
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
                fill="#344054"
              />
            </svg>
            }>Filter</Button>
        </ButtonGroup>
      </Box>
    ),

    renderRowActionMenuItems: ({ closeMenu, row }) => [

      (userPermissionType === "groupadmin" || UserPermissionAllData?.role_details?.settings?.find(permission =>
        permission?.key === "inventory" &&
        permission?.access?.includes("edit")
      )) && (
        <MenuItem
          className='email_'
          onClick={() => {
            handleSubmitActive(row?.original)
            closeMenu()
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Send20Regular />
          </ListItemIcon>
          {row?.original?.product_is_active === true ? "Inactive" : "Active"}
        </MenuItem>),
      (userPermissionType === "groupadmin" || UserPermissionAllData?.role_details?.settings?.find(permission =>
        permission?.key === "inventory" &&
        permission?.access?.includes("edit")
      )) && (
        <MenuItem
          // className='delete_'
          className='email_'
          onClick={() => {
            handleSubmitEdit(row?.original)
            closeMenu()
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Edit20Regular />
          </ListItemIcon>
          Edit
        </MenuItem>)
    ],

    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 40, //set custom width
        muiTableHeadCellProps: {
          align: 'start', //change head cell props
        },
        muiTableRowCellProps: {
          align: 'center',
        },
      },
      'mrt-row-numbers': {
        muiTableHeadCellProps: {
          sx: {
            fontSize: '1.2rem',
          },
        },
      },
      'mrt-row-select': {
        enableColumnActions: true,
        enableHiding: true,
        size: 30,
      },
    },
    enableSortingRemoval: false,
  });


export const tableOptionEmailMarketing = ({
  isRefetching,
  globalFilter,
  sorting,
  windowHeight,
  setGlobalFilter,
  setPagination,
  setSorting,
  rowCount,
  isLoading,
  pagination,
  handleClickColum,
  handleFilterClick,
  filterData,
  handleSubmitActive,
  getMenuList, url23,
  getEmailMarketingList1,
  DisplayCol,
  downloadCSV, CSVLoader, CSVData
}) => ({

  manualSorting: true,
  manualFiltering: true,
  manualPagination: true,
  enableStickyHeader: true,
  enableStickyFooter: true,
  muiTableContainerProps: { sx: { maxHeight: windowHeight - 130 } },
  rowCount,
  icons: fontAwesomeIcons,
  positionGlobalFilter: "left",
  muiTableHeadCellProps: {
    sx: tableHeaderStyle?.headerTitle
  },
  muiTableBodyCellProps: {
    sx: tableHeaderStyle?.headerCell
  },
  muiTableBodyRowProps: { hover: false },
  enableRowSelection: true,
  getRowId: (row) => row.phoneNumber,
  enableColumnFilters: false,
  onGlobalFilterChange: setGlobalFilter,
  onPaginationChange: setPagination,
  onSortingChange: setSorting,
  enableFilterMatchHighlighting: true,
  rowCount,
  state: {
    // columnFilters,
    globalFilter,
    isLoading,
    pagination,
    // showAlertBanner: isError,
    showProgressBars: isRefetching,
    sorting,
  },
  enableFacetedValues: true,
  enableRowActions: true,
  enableRowSelection: false,
  enableColumnFilters: false,
  positionToolbarAlertBanner: 'bottom',
  muiSearchTextFieldProps: {
    size: 'small',
    variant: 'outlined',
    sx: { marginLeft: "auto" },
  },
  enableSortingRemoval: false,
  enableColumnActions: false,

  initialState: {
    showColumnFilters: false,
    showGlobalFilter: true,
    columnPinning: {
      left: ['mrt-row-expand', 'mrt-row-select'],
      right: ['mrt-row-actions'],
    },
  },
  muiPaginationProps: {
    color: 'secondary',
    rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
    shape: 'rounded',
    variant: 'outlined',
  },
  paginationDisplayMode: 'pages',
  renderToolbarInternalActions: ({ table }) => (
    <>
      {CSVLoader === true ?
        <div className='mx-5 my-3'>
          <Loader />
        </div> : (CSVData?.length > 0 &&
          <Button
            onClick={() => downloadCSV(CSVData, `${"Email Marketing Data"} ${moment(new Date()).format("DD-MM-YYYY")}.csv`)}
            className='mx-5 my-3 button_CSV_' variant="outlined" startIcon={<TbFileDownload />}>
            CSV
          </Button>)}
      <Box>
        <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
          <Button onClick={handleClickColum} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
              fill="#344054"
            />
          </svg>
          } > Display</Button>
          <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
            startIcon={<svg
              width={19}
              height={18}
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
                fill="#344054"
              />
            </svg>
            }>Filter</Button>
        </ButtonGroup>
      </Box>
    </>
  ),
  renderRowActionMenuItems: ({ closeMenu, row }) => [
    // Conditional rendering based on user permissions and row data
    (userPermissionType_ || EmailMarketingPermissions?.access?.includes("edit")) && (
      <MenuItem
        key="subscribe-toggle"
        className="email_"
        onClick={() => {
          const item = {
            want_to_recieve_offers: !row?.original?.want_to_recieve_offers,
            email: row?.original?.email,
          };
          handleSubmitActive(item);
          closeMenu();
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          {row?.original?.want_to_recieve_offers ? (
            <ThumbDislikeRegular style={{ fontSize: 20 }} />
          ) : (
            <ThumbLikeRegular style={{ fontSize: 20 }} />
          )}
        </ListItemIcon>
        {row?.original?.want_to_recieve_offers ? "Unsubscribe" : "Subscribe"}
      </MenuItem>
    ),

    // Delete action menu item
    (userPermissionType_ || EmailMarketingPermissions?.access?.includes("delete")) && (
      <MenuItem
        key="delete"
        className="delete_"
        onClick={() => {
          closeMenu();
          const item = {
            email: row?.original?.email,
          };
          deleteCommonFunction(
            `/groupadmin/offers/deleteUser`,
            "Details have been deleted successfully.",
            () => getEmailMarketingList1(),
            item
          );
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <Delete20Regular style={{ color: "rgb(242, 80, 66)", fontSize: 20 }} />
        </ListItemIcon>
        Delete
      </MenuItem>
    ),
  ],

  displayColumnDefOptions: {
    'mrt-row-actions': {
      size: 40, //set custom width
      muiTableHeadCellProps: {
        align: 'start', //change head cell props
      },
      muiTableRowCellProps: {
        align: 'center',
      },
    },
    'mrt-row-numbers': {
      muiTableHeadCellProps: {
        sx: {
          fontSize: '1.2rem',
        },
      },
    },
    'mrt-row-select': {
      enableColumnActions: true,
      enableHiding: true,
      size: 30,
    },
  },
  enableSortingRemoval: false,
});


export const tableOptionEnquiryManagment = ({
  isRefetching,
  globalFilter,
  sorting, history,
  windowHeight,
  setGlobalFilter,
  setPagination,
  setSorting,
  rowCount,
  isLoading,
  pagination,
  handleClickColum_,
  handleFilterClick,
  filterData,
  handleSubmitActive,
  Type, handleFilterColor,
  getCompletedEnquiry,
  DisplayCol,
  downloadCSV, CSVLoader, CSVData
}) => ({

  manualSorting: true,
  manualFiltering: true,
  manualPagination: true,
  enableStickyHeader: true,
  enableStickyFooter: true,
  muiTableContainerProps: { sx: { maxHeight: windowHeight - 175 } },
  rowCount,
  icons: fontAwesomeIcons,
  positionGlobalFilter: "left",
  muiTableHeadCellProps: {
    sx: tableHeaderStyle?.headerTitle
  },
  muiTableBodyCellProps: {
    sx: tableHeaderStyle?.headerCell
  },
  muiTableBodyRowProps: { hover: false },
  enableRowSelection: true,
  getRowId: (row) => row.phoneNumber,
  enableColumnFilters: false,
  onGlobalFilterChange: setGlobalFilter,
  onPaginationChange: setPagination,
  onSortingChange: setSorting,
  enableFilterMatchHighlighting: true,
  rowCount,
  state: {
    // columnFilters,
    globalFilter,
    isLoading,
    pagination,
    // showAlertBanner: isError,
    showProgressBars: isRefetching,
    sorting,
  },
  enableFacetedValues: true,
  enableRowActions: true,
  enableRowSelection: false,
  enableColumnFilters: false,
  positionToolbarAlertBanner: 'bottom',
  muiSearchTextFieldProps: {
    size: 'small',
    variant: 'outlined',
    sx: { marginLeft: "auto" },
  },
  enableSortingRemoval: false,
  enableColumnActions: false,

  initialState: {
    showColumnFilters: false,
    showGlobalFilter: true,
    columnPinning: {
      left: ['mrt-row-expand', 'mrt-row-select'],
      right: ['mrt-row-actions'],
    },
  },
  muiPaginationProps: {
    color: 'secondary',
    rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
    shape: 'rounded',
    variant: 'outlined',
  },
  paginationDisplayMode: 'pages',
  renderToolbarInternalActions: ({ table }) => (
    <Box>
      <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
        <Button onClick={handleClickColum_} style={{ background: handleFilterColor() }} className='button_group buttonDisplay' table={table} startIcon={<svg
          width={16}
          height={16}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
            fill="#344054"
          />
        </svg>
        } > Display</Button>
        <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
          startIcon={<svg
            width={19}
            height={18}
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
              fill="#344054"
            />
          </svg>
          }>Filter</Button>
      </ButtonGroup>
    </Box>
  ),
  renderRowActionMenuItems: ({ closeMenu, row }) => [
    // Conditional rendering based on user permissions and row data
    <MenuItem
      key="subscribe-toggle"
      className="email_"
      onClick={() => {
        if (Type === "completed_enquiry") {
          history.push(`/group_admin/enquiry/completed_enquiry_view/${row?.original?._id}`)
        } else if (Type === "pending_enquiry") {
          history.push(`/group_admin/enquiry/pending_enquiry_view/${row?.original?._id}`)
        }
        closeMenu();
      }}
      sx={{ m: 0 }}
    >
      <ListItemIcon>
        <Eye20Filled />
      </ListItemIcon>
      View
    </MenuItem>
  ],

  displayColumnDefOptions: {
    'mrt-row-actions': {
      size: 40, //set custom width
      muiTableHeadCellProps: {
        align: 'start', //change head cell props
      },
      muiTableRowCellProps: {
        align: 'center',
      },
    },
    'mrt-row-numbers': {
      muiTableHeadCellProps: {
        sx: {
          fontSize: '1.2rem',
        },
      },
    },
    'mrt-row-select': {
      enableColumnActions: true,
      enableHiding: true,
      size: 30,
    },
  },
  enableSortingRemoval: false,
});

export const tableOptionMenuProducts = ({ getMenuList, url23,
  handleClickColum_, handleSubmitActive, windowHeight,
  filterData,
  DisplayCol,
  handleFilterClick }) => ({
    icons: fontAwesomeIcons,
    positionGlobalFilter: "left",
    muiTableHeadCellProps: {
      sx: tableHeaderStyle?.headerTitle
    },
    muiTableBodyCellProps: {
      sx: tableHeaderStyle?.headerCell
    },
    muiTableBodyRowProps: { hover: false },
    enableRowSelection: true,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: false,
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
      sx: { marginLeft: "auto" },
    },
    // autoResetPageIndex: false,
    state: { getMenuList },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
      shape: 'rounded',
      variant: 'outlined',
    },
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
          <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
              fill="#344054"
            />
          </svg>
          } > Display</Button>
          <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
            startIcon={<svg
              width={19}
              height={18}
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
                fill="#344054"
              />
            </svg>
            }>Filter</Button>
        </ButtonGroup>
      </Box>
    ),

    renderRowActionMenuItems: ({ closeMenu, row }) => [

      // (userPermissionType_ || MenuPermissions?.access?.includes("edit")) && (
      //   <MenuItem
      //     className='email_'
      //     onClick={() => {
      //       handleSubmitActive(row?.original?._id, !row?.original?.is_active)
      //       closeMenu()
      //     }}
      //     sx={{ m: 0 }}
      //   >
      //     <ListItemIcon>
      //       <Send20Regular />
      //     </ListItemIcon>
      //     {row?.original?.is_active === true ? "Inactive" : "Active"}
      //   </MenuItem>),
      // (userPermissionType_ || MenuPermissions?.access?.includes("delete")) && (
      //   <MenuItem
      //     className='delete_'
      //     onClick={() => {
      //       closeMenu();
      //       if (url23 === "menu_management") {
      //         // const endpoint = '/groupadmin/menu';
      //         // deleteData(endpoint, row?.original?._id, getMenuList, "Menu has been deleted successfully.");
      //         deleteCommonFunction(`/groupadmin/menu/${row?.original?._id}`, "Menu has been deleted successfully.", () => getMenuList());
      //       }
      //     }}
      //     sx={{ m: 0 }}
      //   >
      //     <ListItemIcon>
      //       <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
      //     </ListItemIcon>
      //     Delete
      //   </MenuItem>)
    ],

    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 40, //set custom width
        muiTableHeadCellProps: {
          align: 'start', //change head cell props
        },
        muiTableRowCellProps: {
          align: 'center',
        },
      },
      'mrt-row-numbers': {
        muiTableHeadCellProps: {
          sx: {
            fontSize: '1.2rem',
          },
        },
      },
      'mrt-row-select': {
        enableColumnActions: true,
        enableHiding: true,
        size: 30,
      },
    },
    enableSortingRemoval: false,
  });

export const tableOptionBranchList = ({ getBranchList, url,
  handleClickColum_, windowHeight, DELETE, VIEW, EDIT, history, getBranchDetaisById,
  getUserManagmentList, UserDetailsGet, handleEditDiscountReasons, handleEditArea, handleEditTableData,
  filterData, groupAdminReasonList, id, getAreaList,
  DisplayCol,
  handleFilterClick }) => ({
    icons: fontAwesomeIcons,
    positionGlobalFilter: "left",
    muiTableHeadCellProps: {
      sx: tableHeaderStyle?.headerTitle
    },
    muiTableBodyCellProps: {
      sx: tableHeaderStyle?.headerCell
    },
    muiTableBodyRowProps: { hover: false },
    enableRowSelection: true,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: false,
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
      sx: { marginLeft: "auto" },
    },
    // autoResetPageIndex: false,
    state: { getBranchList, getBranchDetaisById, getUserManagmentList, UserDetailsGet, groupAdminReasonList },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
      shape: 'rounded',
      variant: 'outlined',
    },
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
          <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
              fill="#344054"
            />
          </svg>
          } > Display</Button>
          <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
            startIcon={<svg
              width={19}
              height={18}
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
                fill="#344054"
              />
            </svg>
            }>Filter</Button>
        </ButtonGroup>
      </Box>
    ),


    renderRowActionMenuItems: ({ closeMenu, row }) => {
      const menuItems = [];
      if (url === "table_management") {
        if (userPermissionType_ || EDIT) {
          (menuItems.push(
            <MenuItem
              className='email_'
              onClick={() => {
                handleEditTableData(row?.original)
                closeMenu()
              }}
              sx={{ m: 0 }}
            >
              <ListItemIcon>
                <Edit20Regular />
              </ListItemIcon>
              Edit Table
            </MenuItem>))
        }
        if (userPermissionType_ || DELETE) {
          (menuItems.push(
            <MenuItem
              className='delete_'
              onClick={() => {
                deleteCommonFunction(`/groupadmin/table/${row?.original?._id}`, "Table has been deleted successfully.", () => getBranchDetaisById(id));
                closeMenu();
              }}
              sx={{ m: 0 }}
            >
              <ListItemIcon>
                <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
              </ListItemIcon>
              Delete
            </MenuItem>))
        }
      } else if (url === "user_management") {
        menuItems.push(
          <MenuItem
            className='email_'
            onClick={() => {
              history.push(`/group_admin/settings/user_management/edit_user/${row?.original?._id}`)
              closeMenu()
            }}
            sx={{ m: 0 }}
          >
            <ListItemIcon>
              <PersonEdit20Regular />
            </ListItemIcon>
            Edit User
          </MenuItem>)
        menuItems.push(<MenuItem
          className='delete_'
          onClick={() => {
            closeMenu();
            deleteCommonFunction(`/groupadmin/user/${row?.original?._id}`, "User has been deleted successfully.", () => getUserManagmentList());
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
          </ListItemIcon>
          Delete User
        </MenuItem>)
      } else if (url === "reasons_management") {
        if (userPermissionType_ || EDIT) {
          (menuItems.push(
            <MenuItem
              className='email_'
              onClick={() => {
                handleEditDiscountReasons(row?.original)
                closeMenu()
              }}
              sx={{ m: 0 }}
            >
              <ListItemIcon>
                <Edit20Regular />
              </ListItemIcon>
              Edit Reason
            </MenuItem>))
        }
        if (userPermissionType_ || DELETE) {
          (menuItems.push(<MenuItem
            className='delete_'
            onClick={() => {
              closeMenu();
              deleteCommonFunction(`/groupadmin/discount/${row?.original?._id}`, "Discount reasons has been deleted successfully.", () => groupAdminReasonList());
            }}
            sx={{ m: 0 }}
          >
            <ListItemIcon>
              <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
            </ListItemIcon>
            Delete Reason
          </MenuItem>))
        }
      }
      else if (url === "roles") {
        menuItems.push(<MenuItem
          className='delete_'
          onClick={() => {
            closeMenu();
            deleteCommonFunction(`/groupadmin/role/${row?.original?._id}`, "Role has been deleted successfully.", () => UserDetailsGet());
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
          </ListItemIcon>
          Delete Role
        </MenuItem>)
      }
      else if (url === "area_list") {
        menuItems.push(
          <MenuItem
            className='email_'
            onClick={() => {
              handleEditArea(row?.original)
              closeMenu()
            }}
            sx={{ m: 0 }}
          >
            <ListItemIcon>
              <Edit20Regular />
            </ListItemIcon>
            Edit Area
          </MenuItem>)
        menuItems.push(<MenuItem
          className='delete_'
          onClick={() => {
            closeMenu();
            deleteCommonFunction(`/groupadmin/table/area/${row?.original?._id}`,
              "Area has been deleted successfully.",
              () => getAreaList(id));
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
          </ListItemIcon>
          Delete Area
        </MenuItem>)
      }
      else {
        if (userPermissionType_ || EDIT) {
          (menuItems.push(
            <MenuItem
              className='email_'
              onClick={() => {
                if (url === "branch_management") {
                  history.push(`/group_admin/branch_management/edit_branch_details/${row?.original?._id}`)
                }
                // else {
                //   openEditModal(row?.original?._id, row?.original?.name)
                // }
                closeMenu()
              }}
              sx={{ m: 0 }}
            >
              <ListItemIcon>
                <Edit20Regular />
              </ListItemIcon>
              Edit
            </MenuItem>))
        };
        if (userPermissionType_ || DELETE) {
          menuItems.push(<MenuItem
            className='delete_'
            onClick={() => {
              closeMenu();
              if (url === "branch_management") {
                deleteCommonFunction(`/groupadmin/branch/${row?.original?._id}`, "Branch has been deleted successfully.", () => getBranchList());
              } else {
                let item = {
                  categoryId: row?.original?._id
                }
                deleteCommonFunction(`/groupAdmin/printer-category/delete-printer-data`, "Category has been deleted successfully.", () => getBranchList(), item);
              }
            }}
            sx={{ m: 0 }}
          >
            <ListItemIcon>
              <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
            </ListItemIcon>
            Delete
          </MenuItem>)
        };
      }
      return menuItems;
    },

    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 40, //set custom width
        muiTableHeadCellProps: {
          align: 'start', //change head cell props
        },
        muiTableRowCellProps: {
          align: 'center',
        },
      },
      'mrt-row-numbers': {
        muiTableHeadCellProps: {
          sx: {
            fontSize: '1.2rem',
          },
        },
      },
      'mrt-row-select': {
        enableColumnActions: true,
        enableHiding: true,
        size: 30,
      },
    },
    enableSortingRemoval: false,
  });

export const tableOptionBranchManagerList = ({ getBranchList, url,
  handleClickColum_, windowHeight, DELETE, VIEW, EDIT, history, getBranchDetaisById, id,
  filterData,
  DisplayCol,
  handleFilterClick }) => ({
    icons: fontAwesomeIcons,
    positionGlobalFilter: "left",
    muiTableHeadCellProps: {
      sx: tableHeaderStyle?.headerTitle
    },
    muiTableBodyCellProps: {
      sx: tableHeaderStyle?.headerCell
    },
    muiTableBodyRowProps: { hover: false },
    enableRowSelection: true,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: false,
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
      sx: { marginLeft: "auto" },
    },
    // autoResetPageIndex: false,
    state: { getBranchList, getBranchDetaisById },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
      shape: 'rounded',
      variant: 'outlined',
    },
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        {/* <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
          <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
              fill="#344054"
            />
          </svg>
          } > Display</Button>
          <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
            startIcon={<svg
              width={19}
              height={18}
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
                fill="#344054"
              />
            </svg>
            }>Filter</Button>
        </ButtonGroup> */}
      </Box>
    ),


    renderRowActionMenuItems: ({ closeMenu, row }) => {
      const menuItems = [];
      if (userPermissionType_ || EDIT) {
        (menuItems.push(
          <MenuItem
            className='email_'
            onClick={() => {
              history.push(`/group_admin/branch_management/edit_manager_details/${row?.original?._id}`)
              closeMenu()
            }}
            sx={{ m: 0 }}
          >
            <ListItemIcon>
              <Edit20Regular />
            </ListItemIcon>
            Edit
          </MenuItem>))
      };
      if (userPermissionType_ || DELETE) {
        menuItems.push(<MenuItem
          className='delete_'
          onClick={() => {
            closeMenu();
            deleteCommonFunction(`/groupadmin/manager/${row?.original?._id}`, "Manager has been deleted successfully.", () => getBranchDetaisById(id));
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
          </ListItemIcon>
          Delete
        </MenuItem>)
      };
      return menuItems;
    },

    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 40, //set custom width
        muiTableHeadCellProps: {
          align: 'start', //change head cell props
        },
        muiTableRowCellProps: {
          align: 'center',
        },
      },
      'mrt-row-numbers': {
        muiTableHeadCellProps: {
          sx: {
            fontSize: '1.2rem',
          },
        },
      },
      'mrt-row-select': {
        enableColumnActions: true,
        enableHiding: true,
        size: 30,
      },
    },
    enableSortingRemoval: false,
  });

export const tableOptionBranchKitchenStaffList = ({ getBranchList, url,
  handleClickColum_, windowHeight, DELETE, VIEW, EDIT, history, getBranchDetaisById, id,
  filterData,
  DisplayCol,
  handleFilterClick }) => ({
    icons: fontAwesomeIcons,
    positionGlobalFilter: "left",
    muiTableHeadCellProps: {
      sx: tableHeaderStyle?.headerTitle
    },
    muiTableBodyCellProps: {
      sx: tableHeaderStyle?.headerCell
    },
    muiTableBodyRowProps: { hover: false },
    enableRowSelection: true,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: false,
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
      sx: { marginLeft: "auto" },
    },
    // autoResetPageIndex: false,
    state: { getBranchList, getBranchDetaisById },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
      shape: 'rounded',
      variant: 'outlined',
    },
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        {/* <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
          <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
              fill="#344054"
            />
          </svg>
          } > Display</Button>
          <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
            startIcon={<svg
              width={19}
              height={18}
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
                fill="#344054"
              />
            </svg>
            }>Filter</Button>
        </ButtonGroup> */}
      </Box>
    ),


    renderRowActionMenuItems: ({ closeMenu, row }) => {
      const menuItems = [];
      if (userPermissionType_ || EDIT) {
        (menuItems.push(
          <MenuItem
            className='email_'
            onClick={() => {
              history.push(`/group_admin/branch_management/edit_staff_details/${row?.original?._id}`)
              closeMenu()
            }}
            sx={{ m: 0 }}
          >
            <ListItemIcon>
              <Edit20Regular />
            </ListItemIcon>
            Edit
          </MenuItem>))
      };
      if (userPermissionType_ || DELETE) {
        menuItems.push(<MenuItem
          className='delete_'
          onClick={() => {
            closeMenu();
            deleteCommonFunction(`/groupadmin/kitchenuser/${row?.original?._id}`, "Kitchen staff has been deleted successfully.", () => getBranchDetaisById(id));
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
          </ListItemIcon>
          Delete
        </MenuItem>)
      };
      return menuItems;
    },

    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 40, //set custom width
        muiTableHeadCellProps: {
          align: 'start', //change head cell props
        },
        muiTableRowCellProps: {
          align: 'center',
        },
      },
      'mrt-row-numbers': {
        muiTableHeadCellProps: {
          sx: {
            fontSize: '1.2rem',
          },
        },
      },
      'mrt-row-select': {
        enableColumnActions: true,
        enableHiding: true,
        size: 30,
      },
    },
    enableSortingRemoval: false,
  });

export const tableOptionBranchServiceStaffStaffList = ({ getBranchList, url,
  handleClickColum_, windowHeight, DELETE, VIEW, EDIT, history, getBranchDetaisById, id,
  filterData, ServiceStaffUrl,
  DisplayCol,
  handleFilterClick }) => ({
    icons: fontAwesomeIcons,
    positionGlobalFilter: "left",
    muiTableHeadCellProps: {
      sx: tableHeaderStyle?.headerTitle
    },
    muiTableBodyCellProps: {
      sx: tableHeaderStyle?.headerCell
    },
    muiTableBodyRowProps: { hover: false },
    enableRowSelection: true,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: false,
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
      sx: { marginLeft: "auto" },
    },
    // autoResetPageIndex: false,
    state: { getBranchList, getBranchDetaisById },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
      shape: 'rounded',
      variant: 'outlined',
    },
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        {/* <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
          <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
              fill="#344054"
            />
          </svg>
          } > Display</Button>
          <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
            startIcon={<svg
              width={19}
              height={18}
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
                fill="#344054"
              />
            </svg>
            }>Filter</Button>
        </ButtonGroup> */}
      </Box>
    ),

    renderRowActionMenuItems: ({ closeMenu, row }) => {
      const menuItems = [];
      if (userPermissionType_ || EDIT) {
        (menuItems.push(
          <MenuItem
            className='email_'
            onClick={() => {
              history.push(`/group_admin/branch_management/edit_servicestaff_details/${row?.original?._id}`)
              closeMenu()
            }}
            sx={{ m: 0 }}
          >
            <ListItemIcon>
              <Edit20Regular />
            </ListItemIcon>
            Edit
          </MenuItem>))
      };
      if (userPermissionType_ || DELETE) {
        menuItems.push(<MenuItem
          className='delete_'
          onClick={() => {
            closeMenu();
            deleteCommonFunction(`/groupadmin/waiter/${row?.original?._id}`, "Service staff has been deleted successfully.", () => getBranchDetaisById(id));
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
          </ListItemIcon>
          Delete
        </MenuItem>)
      };
      return menuItems;
    },

    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 40, //set custom width
        muiTableHeadCellProps: {
          align: 'start', //change head cell props
        },
        muiTableRowCellProps: {
          align: 'center',
        },
      },
      'mrt-row-numbers': {
        muiTableHeadCellProps: {
          sx: {
            fontSize: '1.2rem',
          },
        },
      },
      'mrt-row-select': {
        enableColumnActions: true,
        enableHiding: true,
        size: 30,
      },
    },
    enableSortingRemoval: false,
  });

export const tableOptionPrinterList = ({ getPrinterList, url, getPrinterCategoryList,
  handleClickColum_, windowHeight, DELETE, VIEW, EDIT, history, openEditModal,
  filterData,
  DisplayCol,
  handleFilterClick }) => ({
    icons: fontAwesomeIcons,
    positionGlobalFilter: "left",
    muiTableHeadCellProps: {
      sx: tableHeaderStyle?.headerTitle
    },
    muiTableBodyCellProps: {
      sx: tableHeaderStyle?.headerCell
    },
    muiTableBodyRowProps: { hover: false },
    enableRowSelection: true,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: false,
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
      sx: { marginLeft: "auto" },
    },
    // autoResetPageIndex: false,
    state: { getPrinterList, getPrinterCategoryList },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
      shape: 'rounded',
      variant: 'outlined',
    },
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
          <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
              fill="#344054"
            />
          </svg>
          } > Display</Button>
          <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
            startIcon={<svg
              width={19}
              height={18}
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
                fill="#344054"
              />
            </svg>
            }>Filter</Button>
        </ButtonGroup>
      </Box>
    ),

    renderRowActionMenuItems: ({ closeMenu, row }) => [

      (userPermissionType_ || EDIT) && (
        <MenuItem
          className='email_'
          onClick={() => {
            if (url === "printerList") {
              history.push(`/group_admin/settings/printer/printerEdit/${row?.original?._id}`)
            } else {
              openEditModal(row?.original?._id, row?.original?.name)
            }
            closeMenu()
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Edit20Regular />
          </ListItemIcon>
          Edit
        </MenuItem>),
      (userPermissionType_ || DELETE) && (
        <MenuItem
          className='delete_'
          onClick={() => {
            closeMenu();
            if (url === "printerList") {
              deleteCommonFunction(`/groupAdmin/branchPrinter/${row?.original?._id}`, "Printer has been deleted successfully.", () => getPrinterList());
            } else {
              let item = {
                categoryId: row?.original?._id
              }
              deleteCommonFunction(`/groupAdmin/printer-category/delete-printer-data`, "Category has been deleted successfully.", () => getPrinterCategoryList(), item);
            }
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
          </ListItemIcon>
          Delete
        </MenuItem>)
    ],

    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 40, //set custom width
        muiTableHeadCellProps: {
          align: 'start', //change head cell props
        },
        muiTableRowCellProps: {
          align: 'center',
        },
      },
      'mrt-row-numbers': {
        muiTableHeadCellProps: {
          sx: {
            fontSize: '1.2rem',
          },
        },
      },
      'mrt-row-select': {
        enableColumnActions: true,
        enableHiding: true,
        size: 30,
      },
    },
    enableSortingRemoval: false,
  });

  export const tableOptionPrintTypeList = ({ getPrinterList, url, getPrinterCategoryList,
  handleClickColum_, windowHeight, DELETE, VIEW, EDIT, history, openEditModal,
  filterData,
  DisplayCol,
  handleFilterClick }) => ({
    icons: fontAwesomeIcons,
    positionGlobalFilter: "left",
    muiTableHeadCellProps: {
      sx: tableHeaderStyle?.headerTitle
    },
    muiTableBodyCellProps: {
      sx: tableHeaderStyle?.headerCell
    },
    muiTableBodyRowProps: { hover: false },
    enableRowSelection: true,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    enableFacetedValues: true,
    enableRowActions: false,
    enableRowSelection: false,
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
      sx: { marginLeft: "auto" },
    },
    // autoResetPageIndex: false,
    state: { getPrinterList, getPrinterCategoryList },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
      shape: 'rounded',
      variant: 'outlined',
    },
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
          <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
              fill="#344054"
            />
          </svg>
          } > Display</Button>
          <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
            startIcon={<svg
              width={19}
              height={18}
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
                fill="#344054"
              />
            </svg>
            }>Filter</Button>
        </ButtonGroup>
      </Box>
    ),

    renderRowActionMenuItems: ({ closeMenu, row }) => [

      (userPermissionType_ || EDIT) && (
        <MenuItem
          className='email_'
          onClick={() => {
            if (url === "printerList") {
              history.push(`/group_admin/settings/printer/printerEdit/${row?.original?._id}`)
            } else {
              openEditModal(row?.original?._id, row?.original?.name)
            }
            closeMenu()
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Edit20Regular />
          </ListItemIcon>
          Edit
        </MenuItem>),
      (userPermissionType_ || DELETE) && (
        <MenuItem
          className='delete_'
          onClick={() => {
            closeMenu();
            if (url === "printerList") {
              deleteCommonFunction(`/groupAdmin/branchPrinter/${row?.original?._id}`, "Printer has been deleted successfully.", () => getPrinterList());
            } else {
              let item = {
                categoryId: row?.original?._id
              }
              deleteCommonFunction(`/groupAdmin/printer-category/delete-printer-data`, "Category has been deleted successfully.", () => getPrinterCategoryList(), item);
            }
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
          </ListItemIcon>
          Delete
        </MenuItem>)
    ],

    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 40, //set custom width
        muiTableHeadCellProps: {
          align: 'start', //change head cell props
        },
        muiTableRowCellProps: {
          align: 'center',
        },
      },
      'mrt-row-numbers': {
        muiTableHeadCellProps: {
          sx: {
            fontSize: '1.2rem',
          },
        },
      },
      'mrt-row-select': {
        enableColumnActions: true,
        enableHiding: true,
        size: 30,
      },
    },
    enableSortingRemoval: false,
  });


export const tableOptionEmailTemplate = ({ getPrinterList, url, getPrinterCategoryList,
  handleClickColum_, windowHeight, DELETE, VIEW, EDIT, history, openEditModal,
  filterData,
  DisplayCol,
  handleFilterClick }) => ({
    icons: fontAwesomeIcons,
    positionGlobalFilter: "left",
    muiTableHeadCellProps: {
      sx: tableHeaderStyle?.headerTitle
    },
    muiTableBodyCellProps: {
      sx: tableHeaderStyle?.headerCell
    },
    muiTableBodyRowProps: { hover: false },
    enableRowSelection: true,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: false,
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
      sx: { marginLeft: "auto" },
    },
    // autoResetPageIndex: false,
    state: { getPrinterList, getPrinterCategoryList },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
      shape: 'rounded',
      variant: 'outlined',
    },
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
          <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
              fill="#344054"
            />
          </svg>
          } > Display</Button>
          <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
            startIcon={<svg
              width={19}
              height={18}
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
                fill="#344054"
              />
            </svg>
            }>Filter</Button>
        </ButtonGroup>
      </Box>
    ),

    renderRowActionMenuItems: ({ closeMenu, row }) => [

      (userPermissionType_ || EDIT) && (
        <MenuItem
          className='email_'
          onClick={() => {
            console.log("url", url)
            if (url === "emailtemplatelist") {
              history.push(`/group_admin/settings/emailtemplate/editemailtemplate/${row?.original?._id}`)
            }
            closeMenu()
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Edit20Regular />
          </ListItemIcon>
          Edit
        </MenuItem>),
      // (userPermissionType_ || DELETE) && (
      //   <MenuItem
      //     className='delete_'
      //     onClick={() => {
      //       closeMenu();
      //       if (url === "printerList") {
      //         deleteCommonFunction(`/groupAdmin/branchPrinter/${row?.original?._id}`, "Printer has been deleted successfully.", () => getPrinterList());
      //       } else {
      //         let item = {
      //           categoryId: row?.original?._id
      //         }
      //         deleteCommonFunction(`/groupAdmin/printer-category/delete-printer-data`, "Category has been deleted successfully.", () => getPrinterCategoryList(), item);
      //       }
      //     }}
      //     sx={{ m: 0 }}
      //   >
      //     <ListItemIcon>
      //       <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
      //     </ListItemIcon>
      //     Delete
      //   </MenuItem>)
    ],

    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 40, //set custom width
        muiTableHeadCellProps: {
          align: 'start', //change head cell props
        },
        muiTableRowCellProps: {
          align: 'center',
        },
      },
      'mrt-row-numbers': {
        muiTableHeadCellProps: {
          sx: {
            fontSize: '1.2rem',
          },
        },
      },
      'mrt-row-select': {
        enableColumnActions: true,
        enableHiding: true,
        size: 30,
      },
    },
    enableSortingRemoval: false,
  });

export const tableOptionBranchListForAdditionalInvoiceText = ({ getPrinterList, url, getPrinterCategoryList,
  handleClickColum_, windowHeight, DELETE, VIEW, EDIT, history, openEditModal,
  filterData,
  DisplayCol,
  handleFilterClick }) => ({
    icons: fontAwesomeIcons,
    positionGlobalFilter: "left",
    muiTableHeadCellProps: {
      sx: tableHeaderStyle?.headerTitle
    },
    muiTableBodyCellProps: {
      sx: tableHeaderStyle?.headerCell
    },
    muiTableBodyRowProps: { hover: false },
    enableRowSelection: true,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: false,
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
      sx: { marginLeft: "auto" },
    },
    // autoResetPageIndex: false,
    state: { getPrinterList, getPrinterCategoryList },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
      shape: 'rounded',
      variant: 'outlined',
    },
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
          <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
              fill="#344054"
            />
          </svg>
          } > Display</Button>
          <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
            startIcon={<svg
              width={19}
              height={18}
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
                fill="#344054"
              />
            </svg>
            }>Filter</Button>
        </ButtonGroup>
      </Box>
    ),

    renderRowActionMenuItems: ({ closeMenu, row }) => [

      (userPermissionType_ || EDIT) && (
        <MenuItem
          className='email_'
          onClick={() => {
            console.log("url", url)
            if (url === "emailtemplatelist") {
              history.push(`/group_admin/settings/emailtemplate/editemailtemplate/${row?.original?._id}`)
            }
            closeMenu()
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Edit20Regular />
          </ListItemIcon>
          Edit
        </MenuItem>),
      // (userPermissionType_ || DELETE) && (
      //   <MenuItem
      //     className='delete_'
      //     onClick={() => {
      //       closeMenu();
      //       if (url === "printerList") {
      //         deleteCommonFunction(`/groupAdmin/branchPrinter/${row?.original?._id}`, "Printer has been deleted successfully.", () => getPrinterList());
      //       } else {
      //         let item = {
      //           categoryId: row?.original?._id
      //         }
      //         deleteCommonFunction(`/groupAdmin/printer-category/delete-printer-data`, "Category has been deleted successfully.", () => getPrinterCategoryList(), item);
      //       }
      //     }}
      //     sx={{ m: 0 }}
      //   >
      //     <ListItemIcon>
      //       <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
      //     </ListItemIcon>
      //     Delete
      //   </MenuItem>)
    ],

    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 40, //set custom width
        muiTableHeadCellProps: {
          align: 'start', //change head cell props
        },
        muiTableRowCellProps: {
          align: 'center',
        },
      },
      'mrt-row-numbers': {
        muiTableHeadCellProps: {
          sx: {
            fontSize: '1.2rem',
          },
        },
      },
      'mrt-row-select': {
        enableColumnActions: true,
        enableHiding: true,
        size: 30,
      },
    },
    enableSortingRemoval: false,
  });

  export const tableOptionQRCode = ({ getPrinterList, url, getPrinterCategoryList,
  handleClickColum_, windowHeight, DELETE, VIEW, EDIT, history, handleEditQR,handleDeleteQR,handleDownloadQR, openEditModal,
  filterData,
  DisplayCol,
  handleFilterClick }) => ({
    icons: fontAwesomeIcons,
    positionGlobalFilter: "left",
    muiTableHeadCellProps: {
      sx: tableHeaderStyle?.headerTitle
    },
    muiTableBodyCellProps: {
      sx: tableHeaderStyle?.headerCell
    },
    muiTableBodyRowProps: { hover: false },
    enableRowSelection: true,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: false,
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    // muiSearchTextFieldProps: {
    //   size: 'small',
    //   variant: 'outlined',
    //   sx: { marginLeft: "auto" },
    // },
    // autoResetPageIndex: false,
    state: { getPrinterList, getPrinterCategoryList },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
      shape: 'rounded',
      variant: 'outlined',
    },
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
          <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
              fill="#344054"
            />
          </svg>
          } > Display</Button>
          
        </ButtonGroup>
      </Box>
    ),

    renderRowActionMenuItems: ({ closeMenu, row }) => [

      (userPermissionType_ || EDIT) && (
        <MenuItem
          className='email_'
          onClick={() => {
            handleEditQR(row?.original)
            closeMenu()
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Edit20Regular />
          </ListItemIcon>
          Edit
        </MenuItem>),
      (userPermissionType_ || VIEW) && (
      <MenuItem
          className='email_'
          onClick={() => {
            handleDownloadQR(row?.original)
            closeMenu()
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <DocumentArrowDown20Regular />
          </ListItemIcon>
          Download
        </MenuItem>),
      (userPermissionType_ || DELETE) && (
        <MenuItem
          className='delete_'
          onClick={() => {
            handleDeleteQR(row?.original)
            closeMenu()
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
          </ListItemIcon>
          Delete
        </MenuItem>)
      // (userPermissionType_ || DELETE) && (
      //   <MenuItem
      //     className='delete_'
      //     onClick={() => {
      //       handleDeleteQR(row?.original)
      //     }}
      //     sx={{ m: 0 }}
      //   >
      //     <ListItemIcon>
      //       <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
      //     </ListItemIcon>
      //     Delete
      //   </MenuItem>)
        
    ],

    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 40, //set custom width
        muiTableHeadCellProps: {
          align: 'start', //change head cell props
        },
        muiTableRowCellProps: {
          align: 'center',
        },
      },
      'mrt-row-numbers': {
        muiTableHeadCellProps: {
          sx: {
            fontSize: '1.2rem',
          },
        },
      },
      'mrt-row-select': {
        enableColumnActions: true,
        enableHiding: true,
        size: 30,
      },
    },
    enableSortingRemoval: false,
  });

export const tableOptionCouponAndVoucher = ({ getCouponList, url, getVoucherTemList,
  handleClickColum_, windowHeight, DELETE, VIEW, EDIT, history, handleSendEmail, getBranchList,
  filterData,
  DisplayCol,
  handleFilterClick }) => ({
    icons: fontAwesomeIcons,
    positionGlobalFilter: "left",
    muiTableHeadCellProps: {
      sx: tableHeaderStyle?.headerTitle
    },
    muiTableBodyCellProps: {
      sx: tableHeaderStyle?.headerCell
    },
    muiTableBodyRowProps: { hover: false },
    enableRowSelection: true,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: false,
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
      sx: { marginLeft: "auto" },
    },
    // autoResetPageIndex: false,
    state: { getCouponList, getVoucherTemList },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
      shape: 'rounded',
      variant: 'outlined',
    },
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
          <Button onClick={handleClickColum_} style={{ background: DisplayCol && "#e0e0e045" }} className='button_group buttonDisplay' table={table} startIcon={<svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
              fill="#344054"
            />
          </svg>
          } > Display</Button>
          <Button onClick={handleFilterClick} style={{ background: filterData !== null && "#e0e0e045" }} className='button_group buttonFilter'
            startIcon={<svg
              width={19}
              height={18}
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
                fill="#344054"
              />
            </svg>
            }>Filter</Button>
        </ButtonGroup>
      </Box>
    ),

    renderRowActionMenuItems: ({ closeMenu, row }) => {
      const { _id, branch, voucher_url } = row?.original || {};
      const branchCurrency = branch?.currency;

      const menuItems = [];

      if (url === "purchased_vouchers") {
        menuItems.push(
          <>
            <MenuItem
              key="sendEmail"
              className="email_"
              onClick={() => {
                handleSendEmail(_id, branchCurrency);
                closeMenu();
              }}
              sx={{ m: 0 }}
            >
              <ListItemIcon>
                <Mail20Regular />
              </ListItemIcon>
              Send Email
            </MenuItem>
            {voucher_url &&
              <MenuItem
                key="sendEmail"
                className="email_"
                onClick={() => {
                  window.open(`${voucher_url}`);
                  closeMenu();
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <ArrowDownload20Filled />
                </ListItemIcon>
                Download
              </MenuItem>}
          </>
        );
      } else {
        if (userPermissionType_ || EDIT) {
          const editUrl =
            url === "coupon_management"
              ? `/group_admin/coupon_voucher_management/coupon_management/edit_coupon/${_id}`
              : `/group_admin/coupon_voucher_management/voucher_management/edit_voucher/${_id}/${branchCurrency}`;

          menuItems.push(
            <MenuItem
              key="edit"
              className="email_"
              onClick={() => {
                history.push(editUrl);
                closeMenu();
              }}
              sx={{ m: 0 }}
            >
              <ListItemIcon>
                <Edit20Regular />
              </ListItemIcon>
              Edit
            </MenuItem>
          );
        }
        if (userPermissionType_ || DELETE) {
          const deleteUrl =
            url === "coupon_management"
              ? `/groupadmin/coupon/${_id}`
              : `/groupadmin/available_voucher/${_id}`;

          const successMessage =
            url === "coupon_management"
              ? "Coupon has been deleted successfully."
              : "Voucher has been deleted successfully.";

          const refreshFunction =
            url === "coupon_management" ? getCouponList : getVoucherTemList;

          menuItems.push(
            <MenuItem
              key="delete"
              className="delete_"
              onClick={() => {
                closeMenu();
                deleteCommonFunction(deleteUrl, successMessage, refreshFunction);
              }}
              sx={{ m: 0 }}
            >
              <ListItemIcon>
                <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
              </ListItemIcon>
              Delete
            </MenuItem>
          );
        }
      }
      return menuItems;
    },


    // renderRowActionMenuItems: ({ closeMenu, row }) => [
    //     (userPermissionType_ || EDIT) && (
    //       <MenuItem
    //         className='email_'
    //         onClick={() => {
    //           if (url === "coupon_management") {
    //             history.push(`/group_admin/coupon_voucher_management/coupon_management/edit_coupon/${row?.original?._id}`)
    //           } else if (url === "voucher_templates") {
    //             history.push(`/group_admin/coupon_voucher_management/voucher_management/edit_voucher/${row?.original?._id}/${row?.original?.branch?.currency}`)
    //           }
    //           closeMenu()
    //         }}
    //         sx={{ m: 0 }}
    //       >
    //         <ListItemIcon>
    //           <Edit20Regular />
    //         </ListItemIcon>
    //         Edit
    //       </MenuItem>),
    //     (userPermissionType_ || DELETE) && (
    //       <MenuItem
    //         className='delete_'
    //         onClick={() => {
    //           closeMenu();
    //           if (url === "coupon_management") {
    //             deleteCommonFunction(`/groupadmin/coupon/${row?.original?._id}`, "Coupon has been deleted successfully.", () => getCouponList());
    //           } else if (url === "voucher_templates") {

    //             deleteCommonFunction(`/groupadmin/available_voucher/${row?.original?._id}`, "Voucher has been deleted successfully.", () => getVoucherTemList());
    //           }
    //         }}
    //         sx={{ m: 0 }}
    //       >
    //         <ListItemIcon>
    //           <Delete20Regular style={{ color: "rgb(242, 80, 66)" }} />
    //         </ListItemIcon>
    //         Delete
    //       </MenuItem>)
    // ],

    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableContainerProps: { sx: { maxHeight: windowHeight - 135 } },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 40, //set custom width
        muiTableHeadCellProps: {
          align: 'start', //change head cell props
        },
        muiTableRowCellProps: {
          align: 'center',
        },
      },
      'mrt-row-numbers': {
        muiTableHeadCellProps: {
          sx: {
            fontSize: '1.2rem',
          },
        },
      },
      'mrt-row-select': {
        enableColumnActions: true,
        enableHiding: true,
        size: 30,
      },
    },
    enableSortingRemoval: false,
  });

